export default "__VITE_ASSET__0a6578db__"